module.exports = __webpack_public_path__ + "assets/mollie-secured.4b03c2d1.svg";